import _ from 'lodash'
import { 
    TOGGLE_SETTING_UI_SIDEBAR,
    SYSTEM_BOOT_RESOURCES_LOADED,
    NEW_WAREHOUSE_CREATED,
    EXISTING_WAREHOUSE_UPDATED,
    NEW_USER_CREATED,
    EXISTING_USER_UPDATED,
    UNMAPPED_WOO_CUSTOMER_LOADED,
    INTEGRATION_QB_TERM_LOADED_ADD_TO_SYSTEM,
    INTEGRATION_QB_TAX_LINE_UPDATED_BY_FORM
} from '../actions/types'
import update from 'immutability-helper';

export default function user(state = {
    ui: {
        sidebar: true
    },
    resources: {
        taxes: [],
        terms: [],
        warehouses: [],
        users: [],
        integrations: {
            woo: null,
            links: null,
            qb: {
                id: null,
                reauth: null
            },
            host: null
        }
    },
    woo: {
        unmapped: [
            {key: '0', value: '0', text: 'Not Mapped'}
        ]
    }
}, action = {}) {
    switch(action.type) {
        case INTEGRATION_QB_TAX_LINE_UPDATED_BY_FORM:
            const {line_id, acct_id, acct_name} = action.payload;
            const lineIndex = _.findIndex(state.resources.taxes, i => {
                return parseInt(i.value) === parseInt(line_id);
            });
            
            if (lineIndex > -1) {
                const oldValue = _.cloneDeep(state.resources.taxes[lineIndex]);
                oldValue.acct_id = acct_id;
                oldValue.acct_name = acct_name;
                return update(state, {
                    resources: {
                        taxes: {
                            [lineIndex]: {$set: oldValue}
                        }
                    }
                })
            }
            return state;
            
        case INTEGRATION_QB_TERM_LOADED_ADD_TO_SYSTEM:
            return update(state, {
                resources: {
                    terms: {$set: action.payload}
                }
            });

        case TOGGLE_SETTING_UI_SIDEBAR:
            return update(state, {
                ui: {
                    sidebar: {$set: !state.ui.sidebar}
                }
            });

        case UNMAPPED_WOO_CUSTOMER_LOADED:
            return update(state, {
                woo: {
                    unmapped: {$set: action.payload}
                }
            })

        case SYSTEM_BOOT_RESOURCES_LOADED:
            return update(state, {
                resources: {$set: action.payload}
            })

        case NEW_WAREHOUSE_CREATED:
            return update(state, {
                resources: {
                    warehouses: {$push: [action.payload]}
                }
            })

        case EXISTING_WAREHOUSE_UPDATED: 
            const existingWHid = _.findIndex(state.resources.warehouses, i => {
                return i.key === action.payload.key
            })
            if (existingWHid > -1) {
                return update(state, {
                    resources: {
                        warehouses: {
                            [existingWHid]: {$set: action.payload}
                        }
                    }
                })
            } else {
                return state;
            }

        case NEW_USER_CREATED:
            return update(state, {
                resources: {
                    users: {$push: [action.payload]}
                }
            })

        case EXISTING_USER_UPDATED: 
            const existingUserid = _.findIndex(state.resources.users, i => {
                return i.key === action.payload.user.key
            })
            
            if (action.payload.status === 'Disabled') {
                const userAfterDisabled = state.resources.users.filter(user => {
                    return parseInt(user.value) !== parseInt(action.payload.user.key);
                });
                
                return update(state, {
                    resources: {
                        users: {$set: userAfterDisabled}
                    }
                });
            } else {
                if (existingUserid > -1) {
                    return update(state, {
                        resources: {
                            users: {
                                [existingUserid]: {$set: action.payload.user}
                            }
                        }
                    })
                } else {
                    return update(state, {
                        resources: {
                            users: {$push: [action.payload.user]}
                        }
                    })
                }
            }
        default: return state;
    }
}


// WEBPACK FOOTER //
// ./src/stores/system.js